import * as React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { reduxForm, Field, getFormValues } from 'redux-form'
import '../form.scss'
import { Fields } from './types'
import InputField from '@App/components/fields/InputField'
// @ts-ignore
import { Button } from 'relevant-ui'

class NewJobsForm extends React.Component<any, any> {
  constructor(props: any) {
    super(props)

    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(e) {
    this.props.onSubmit(e, this.props.segmentFormValues)
  }

  render() {
    const { t, canceled, segmentFormValues } = this.props

    const desabled = segmentFormValues
      ? Object.keys(segmentFormValues)?.length !== 1
      : true

    return (
      <form className="form" style={{ padding: '3.9rem 5.7rem' }}>
        <h2 className="title">Ajouter un Job</h2>
        <div className="form__field form__field--large">
          <div className="form__field__label">
            {t('Name')}
          </div>
          <div className="form__field__input">
            <Field
              name={Fields.NAME}
              component={InputField}
              label="Name"
              placeholder="Name..."
              secondary
            />
          </div>
        </div>
        <div className="buttons mt-20">
          <Button
            type="submit"
            label={t('validate')}
            size="large"
            onClick={(e: any) => this.handleClick(e)}
            button="primary"
            disabled={desabled}
          />
          <Button
            className="button secondary large ml-20"
            label={t('cancel')}
            onClick={canceled}
          />
        </div>
      </form>
    )
  }
}

const JobsForm = reduxForm({
  form: Fields.JOB,
  enableReinitialize: true,
})(NewJobsForm as any)

const mapStateToProps = (state: any) => {
  const segmentFormValues = getFormValues(Fields.JOB)(state)
  return {
    segmentFormValues,
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {}
}

export default compose<any>(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps),
)(JobsForm)
